import React from 'react';
import Tooltip from '@src/components/Tooltip';
import { PersonRounded, PublicRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { VOICE_STATUS } from '@src/constants/voiceCloning';

const InfoTooltipStatusVoice = ({ status, placement = 'top' }) => {
  const { t } = useTranslation();
  if (status === VOICE_STATUS.PRIVATE) {
    return (
      <Tooltip arrow title={t('private')} placement={placement}>
        <PersonRounded sx={{ fontSize: '20px !important' }} className="name" />
      </Tooltip>
    );
  }

  if (status === VOICE_STATUS.PUBLIC) {
    return (
      <Tooltip arrow title={t('public')} placement={placement}>
        <PublicRounded sx={{ fontSize: '20px !important' }} className="name" />
      </Tooltip>
    );
  }
  return <></>;
};

export default InfoTooltipStatusVoice;
